module.exports = __webpack_public_path__ + "media/images/icons/close-7de0a36bcced2d13548a4d378b4d598c.svg";